var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditarMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "editar-material",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.113,
    height: 14.133,
    viewBox: "0 0 14.113 14.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_83",
    "data-name": "Grupo 83",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_153",
    "data-name": "Caminho 153",
    d: "M9.181.162.534,8.809a.6.6,0,0,0-.168.382L.3,13.593a.521.521,0,0,0,.168.391.556.556,0,0,0,.391.149H.869L5.141,14.1a.541.541,0,0,0,.391-.149l8.721-8.721a.568.568,0,0,0,0-.791L9.972.153A.577.577,0,0,0,9.181.162ZM4.9,13l-3.472.047.056-3.611L7.254,3.662l3.49,3.49ZM11.526,6.37,8.045,2.88,9.581,1.344l3.481,3.49Z",
    transform: "translate(-0.301 0)",
    fill: "#640000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditarMaterial);
export default __webpack_public_path__ + "static/media/editar-material.0d356d4a46a4c8684e1d11f453eb23c9.svg";
export { ForwardRef as ReactComponent };